const ITEMS = [
  "Housing",
  "Education",
  "Sanitation",
  "Livelihoods",
  "Civic Power",
  "Neighborhood",
  "Dignity",
  "Resilience",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-line bg-cream py-6 overflow-hidden"
    >
      <div className="marquee-track">
        {row.map((it, i) => (
          <span
            key={i}
            className="font-serif italic text-3xl md:text-4xl text-forest/85 mx-8 inline-flex items-center gap-8"
          >
            {it}
            <span className="text-terracotta">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
